import React from "react";

export default function About() {
  return (
    <section id="about">
        <div className="flex justify-center absolute left-0 top-0">
            <img
              className="object-cover object-center rounded opacity-50"
              alt="Logo"
              src="/94358_Galaxy Game Creation_flat_HP_DK_01.png"
            />
        </div>
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            Welcome to Galaxy Game Creation!
            <br className="hidden lg:inline-block" />Unleashing the Universe of Play
          </h1>
          <p className="mb-8 leading-relaxed">
          Hello, and welcome to my world of gaming! My name is Danny, an enthusiastic indie game developer who delights in bringing the joy of play to your screens. Gaming for me isn't just a job, it's my passion and favorite hobby. Every pixel, every line of code, every character in my games are lovingly crafted with a sprinkle of joy and a huge helping of enthusiasm. I believe in creating experiences that bring a smile to your face, transport you to fantastical worlds, and make your day just a little bit brighter.
          <br></br>
          <br></br>
          As a small independent developer, your support means the world to me. It fuels my creativity and enables me to continue doing what I love most - making games for you. Whether you're downloading my games, sharing them with friends, or offering feedback, you're a valued part of this creative journey. Every bit of support, big or small, helps me create better, happier, and more exciting games for all. So why not come along for the adventure? Let's make something amazing together!"
          </p>
          {/*<h3 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">Download Now</h3>*/}
          <div className="flex justify-center">
            <a
              href="#contact"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
              Contact Me
            </a>
            <a
              href="#projects"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
              View Projects
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/About.js